<script>
  import Help from "../help.svelte";
  </script>

  <Help helpId={"Help16"} showSearchOption={false} back="/about"/>